import * as React from "react";
const SvgRightChevronIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "30.84 100 18.98 88.14 57.3 49.83 19.33 11.86 31.19 0 81.02 49.83 30.84 100" }));
export default SvgRightChevronIcon;
